import React, { useCallback, useState } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { SimplifiedTable } from 'features/command-center/';
import { ENDPOINTS, TABLES_KEYS } from 'features/command-center/constants';
import { useFeatureFlags } from 'providers/FeatureFlagsProvider';
import strings from 'strings';
import { RowActions } from 'UI/constants/defaults';
import { EntityType } from 'UI/constants/entityTypes';
import { FeatureFlags } from 'UI/constants/featureFlags';
import { loadFromLocalStorage } from 'UI/utils';

import { COLUMNS, ORDER_BY_OPTIONS, VIRTUAL_PROPS } from './HotJobOrders.constants';
import { formatResponse } from './HotJobOrders.utils';
import { useStyles } from './styles';

/**
 * @typedef {Object} HotJobOrdersProps
 * @property {Filters[]} filters
 */

const COPIES = strings.commandCenter.dominateSheet.hotJobOrders;
const ENDPOINT = ENDPOINTS.hotInventoryJobOrders;
const PERSISTENCE_KEY = 'active-job-orders-show-pending-verification';

/**
 * @param {HotJobOrdersProps} props
 */
export const HotJobOrders = ({ filters }) => {
  const classes = useStyles();
  const { checkIfFeatureFlagEnabled } = useFeatureFlags();
  const showVerification = checkIfFeatureFlagEnabled(FeatureFlags.CommandCenterShowVerification);

  const [showPendingToVerify, setShowPendingToVerify] = useState(() =>
    loadFromLocalStorage(PERSISTENCE_KEY, true)
  );

  const handleCheckToggle = (event, checked) => {
    localStorage.setItem(PERSISTENCE_KEY, checked);
    setShowPendingToVerify(checked);
  };

  const extendParams = useCallback(() => {
    return showVerification ? { showPendingToVerify } : null;
  }, [showVerification, showPendingToVerify]);

  return (
    <SimplifiedTable
      columns={COLUMNS}
      endpoint={ENDPOINT}
      entityType={EntityType.Joborder}
      extendParams={extendParams}
      filters={filters}
      formatResponse={formatResponse}
      header={COPIES.title}
      headerAction={
        showVerification ? (
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                checked={showPendingToVerify}
                onChange={handleCheckToggle}
                name="showPendingToVerify"
              />
            }
            label={COPIES.headerAction}
            classes={{ label: classes.labelHeaderActions }}
            onClick={e => e.stopPropagation()}
          />
        ) : null
      }
      orderByOptions={ORDER_BY_OPTIONS}
      pageKey={TABLES_KEYS.dominateActiveJobOrders}
      virtualProps={VIRTUAL_PROPS}
      rowActions={[
        RowActions.View,
        {
          action: 'viewContact',
          name: 'viewContact',
          value: 'contactData'
        }
      ]}
    />
  );
};
